import { IconButton, Tooltip } from '@mui/material'

type WalkthroughTriggerProps = {
  id: string;
  onClick: () => void;
}

function WalkthroughTrigger({id, onClick} : WalkthroughTriggerProps) {
  return (
     <Tooltip title="Walkthrough" arrow placement="right">
        <IconButton
          id={id}
          data-testid={id}
          color="secondary"
          size="medium"
          onClick={onClick}
          sx={{
            '& .walkthrough-star': {
              transformBox: 'fill-box',
              transformOrigin: 'center',
              animation: 'walkthrough-star-pulse 1.4s ease-in-out infinite',
            },
            '@keyframes walkthrough-star-pulse': {
              '0%, 100%': { transform: 'translate(1px, -1px) scale(1)', opacity: 1 },
              '50%': { transform: 'translate(1.5px, -1px) scale(1.6)', opacity: 0.85 },
            },
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            fill="#FF5F47"
            style={{ overflow: 'visible' }}
          >
            <path d="M7,20h4c0,1.1-0.9,2-2,2S7,21.1,7,20z M5,19h8v-2H5V19z M16.5,9.5c0,3.82-2.66,5.86-3.77,6.5H5.27 C4.16,15.36,1.5,13.32,1.5,9.5C1.5,5.36,4.86,2,9,2S16.5,5.36,16.5,9.5z M14.5,9.5C14.5,6.47,12.03,4,9,4S3.5,6.47,3.5,9.5 c0,2.47,1.49,3.89,2.35,4.5h6.3C13.01,13.39,14.5,11.97,14.5,9.5z"/>
            <path className="walkthrough-star" d="M19,6l0.94-2.06L22,3l-2.06-0.94L19,0l-0.94,2.06L16,3l2.06,0.94L19,6z"/>
          </svg>
        </IconButton>
      </Tooltip>
  )
}

export default WalkthroughTrigger
